import { type AggRequest, type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';
import { type LoomSpaceNode } from './types';

const LOOM_SPACES_BY_IDS_OPERATION_NAME = 'LoomRovoSpacesByIdsQuery';
const loomSpacesByIdsQuery = `
	query ${LOOM_SPACES_BY_IDS_OPERATION_NAME}($ids: [ID!]!) {
		loom_spaces(ids: $ids) {
			id
			name
			url
		}
	}
`;

export type LoomSpacesByIdsQueryVariables = {
	ids: string[];
};

export type LoomSpacesByIdsQueryData = {
	loom_spaces: LoomSpaceNode[];
};

export type LoomSpaceARIEntitiesQueryProps = Pick<
	AggRequest<LoomSpacesByIdsQueryVariables>,
	'aggAbsoluteUrl' | 'variables' | 'headers'
>;

export const loomSpaceARIEntitiesQuery = ({
	variables,
	aggAbsoluteUrl,
	headers,
}: LoomSpaceARIEntitiesQueryProps): Promise<AggResponse<LoomSpacesByIdsQueryData>> =>
	fetchAgg<LoomSpacesByIdsQueryVariables, LoomSpacesByIdsQueryData>({
		variables,
		aggAbsoluteUrl,
		graphQuery: loomSpacesByIdsQuery,
		operationName: LOOM_SPACES_BY_IDS_OPERATION_NAME,
		headers,
	});
